var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from "react";
import Editor from "@monaco-editor/react";
import styled from "styled-components";
var EditorWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 200px;\n  max-height: 950px;\n  border: 1px inset;\n  height: ", ";\n"], ["\n  min-height: 200px;\n  max-height: 950px;\n  border: 1px inset;\n  height: ", ";\n"])), function (props) {
  return props.height ? props.height : "400px";
});
var PyEditor = function PyEditor(_a) {
  var editorValue = _a.editorValue,
    setEditorValue = _a.setEditorValue,
    editorHeight = _a.editorHeight,
    setIsEditorReady = _a.setIsEditorReady;
  var handleEditorDidMount = function handleEditorDidMount() {
    setIsEditorReady(true);
  };
  var handleChange = function handleChange(value) {
    if (value) {
      setEditorValue(value);
    }
  };
  return React.createElement(EditorWrapper, {
    height: editorHeight
  }, React.createElement(Editor, {
    value: editorValue,
    language: "python",
    onChange: handleChange,
    onMount: handleEditorDidMount,
    options: {
      minimap: {
        enabled: false
      },
      wordWrap: "on",
      scrollBeyondLastLine: false,
      hideCursorInOverviewRuler: true,
      scrollbar: {
        alwaysConsumeMouseWheel: false
      }
    }
  }));
};
export default PyEditor;
var templateObject_1;